import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import CallDetail from "@/pages/Pages/Call/CallDetail.vue";
import CallGroup from "@/pages/Pages/Call/CallGroup.vue";
import CallGroupIncoming from "@/pages/Pages/Call/CallGroupIncoming.vue";
import CallDetailIncoming from "@/pages/Pages/Call/CallDetailIncoming.vue";
import CallDetailIncomingInfo from "@/pages/Pages/Call/CallDetailIncomingInfo.vue";
import CallOriginatorRules from "@/pages/Pages/Call/CallOriginatorRules.vue";
import CallOriginatorRule from "@/pages/Pages/Call/CallOriginatorRule.vue";
import CallIvrMenus from "@/pages/Pages/Call/CallIvrMenus.vue";
import CallIvrMenu from "@/pages/Pages/Call/CallIvrMenu.vue";
import CallTemplates from "@/pages/Pages/Call/CallTemplates.vue";
import CallTemplate from "@/pages/Pages/Call/CallTemplate.vue";
import CallPartnerTariffZones from "@/pages/Pages/Call/CallPartnerTariffZones.vue";
import CallPartnerTariffZoneGroup from "@/pages/Pages/Call/CallPartnerTariffZoneGroup.vue";
import CallPartnerTariffZone from "@/pages/Pages/Call/CallPartnerTariffZone.vue";
import CallOperatorTariffZoneGroup from "@/pages/Pages/Call/CallOperatorTariffZoneGroup.vue";
import CallOperatorTariffZone from "@/pages/Pages/Call/CallOperatorTariffZone.vue";
import CallOperatorTariffZones from "@/pages/Pages/Call/CallOperatorTariffZones.vue";
import CallSounds from "@/pages/Pages/Call/CallSounds.vue";
import CallSound from "@/pages/Pages/Call/CallSound.vue";
import CallDetailInfo from "@/pages/Pages/Call/CallDetailInfo.vue";

let callMenu = {
  path: "/call",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/call/detail",
  name: "Call",
  children: [
    {
      path: "detail",
      name: "call_detail",
      components: { default: CallDetail },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.detail'
      }
    },
    {
      path: "detail/:id",
      name: "call_detail_info",
      components: { default: CallDetailInfo },
      meta: {
        icon: "call",
        parentPath: "/call/detail",
        msgKey: 'menu.item.statistics.call.detail'
      }
    },
    {
      path: "group",
      name: "call_group",
      components: { default: CallGroup },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.group'
      }
    },
    {
      path: "detail_incoming",
      name: "call_detail_incoming",
      components: { default: CallDetailIncoming },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.mo.detail'
      }
    },
    {
      path: "detail_incoming/:id",
      name: "call_detail_incoming_info",
      components: { default: CallDetailIncomingInfo },
      meta:{
        icon: "call",
        parentPath: "/call/detail_incoming",
        msgKey: 'menu.item.statistics.call.mo.detail'
      }
    },
    {
      path: "group_incoming",
      name: "call_group_incoming",
      components: { default: CallGroupIncoming },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.mo.group'
      }
    },
    {
      path: "originator_rules",
      name: "call_originator_rules",
      components: { default: CallOriginatorRules },
      meta:{
        icon: "call",
        msgKey: 'menu.item.call.pool.rules'
      }
    },
    {
      path: "originator_rules/new",
      name: "call_originator_rules_new",
      components: { default: CallOriginatorRule },
      meta:{
        icon: "call",
        parentPath: "/call/originator_rules",
        msgKey: 'menu.item.call.pool.rules'
      },
    },
    {
      path: "originator_rules/:id",
      name: "call_originator_rules_edit",
      components: { default: CallOriginatorRule },
      meta:{
        icon: "call",
        parentPath: "/call/originator_rules",
        msgKey: 'menu.item.call.pool.rules'
      }
    },
    {
      path: "ivr_menus",
      name: "call_ivr_menus",
      components: { default: CallIvrMenus },
      meta:{
        icon: "call",
        msgKey: 'menu.item.call.ivr'
      }
    },
    {
      path: "ivr_menus/new",
      name: "call_ivr_menus_new",
      components: { default: CallIvrMenu },
      meta:{
        icon: "call",
        parentPath: "/call/ivr_menus",
        msgKey: 'menu.item.call.ivr'
      },
    },
    {
      path: "ivr_menus/:id",
      name: "call_ivr_menus_edit",
      components: { default: CallIvrMenu },
      meta:{
        icon: "call",
        parentPath: "/call/ivr_menus",
        msgKey: 'menu.item.call.ivr'
      }
    },
    {
      path: "sound_library",
      name: "call_sound_library",
      components: { default: CallSounds },
      meta:{
        icon: "call",
        msgKey: 'menu.item.call.sounds'
      }
    },
    {
      path: "sound_library/new",
      name: "call_sound_library_new",
      components: { default: CallSound },
      meta:{
        icon: "call",
        parentPath: "/call/sound_library",
        msgKey: 'menu.item.call.sounds'
      }
    },
    {
      path: "sound_library/:id",
      name: "call_sound_library_view",
      components: { default: CallSound },
      meta:{
        icon: "call",
        parentPath: "/call/sound_library",
        msgKey: 'menu.item.call.sounds'
      }
    },
    {
      path: "tarification/partners",
      name: "call_tarification_partners",
      components: { default: CallPartnerTariffZones },
      meta:{
        icon: "call",
        msgKey: 'menu.item.call.clients.routing'
      }
    },
    {
      path: "tarification/partners/:partner_id/tariff_zone_group",
      name: "call_tarification_partners_group",
      components: { default: CallPartnerTariffZoneGroup },
      meta:{
        icon: "call",
        parentPath: "/call/tarification/partners",
        msgKey: 'menu.item.call.clients.routing'
      }
    },
    {
      path: "tarification/partners/:partner_id/tariff_zone/new",
      name: "call_tarification_partners_new",
      components: { default: CallPartnerTariffZone },
      meta:{
        icon: "call",
        parentPath: "/call/tarification/partners",
        msgKey: 'menu.item.call.clients.routing'
      }
    },
    {
      path: "tarification/partners/:partner_id/tariff_zone/:id",
      name: "call_tarification_partners_edit",
      components: { default: CallPartnerTariffZone },
      meta:{
        icon: "call",
        parentPath: "/call/tarification/partners",
        msgKey: 'menu.item.call.clients.routing'
      }
    },
      {
          path: "templates",
          name: "call_templates",
          components: { default: CallTemplates },
          meta:{
              icon: "call",
              msgKey: 'menu.item.call.templates'
          }
      },
      {
          path: "templates/new",
          name: "call_templates_new",
          components: { default: CallTemplate },
          meta:{
              icon: "call",
              parentPath: "/call/templates",
              msgKey: 'menu.item.call.templates'
          },
      },
      {
          path: "templates/:id",
          name: "call_templates_edit",
          components: { default: CallTemplate },
          meta:{
              icon: "call",
              parentPath: "/call/templates",
              msgKey: 'menu.item.call.templates'
          }
      },
    {
      path: "tarification/service_providers",
      name: "call_tarification_operators",
      components: { default: CallOperatorTariffZones },
      meta:{
        icon: "call",
        msgKey: 'menu.item.call.provider.routing'
      }
    },
    {
      path: "tarification/service_providers/:operator_id/tariff_zone_group",
      name: "call_tarification_operators_group",
      components: { default: CallOperatorTariffZoneGroup },
      meta:{
        icon: "call",
        parentPath: "/call/tarification/service_providers",
        msgKey: 'menu.item.call.provider.routing'
      }
    },
    {
      path: "tarification/service_providers/:operator_id/tariff_zone/new",
      name: "call_tarification_operators_new",
      components: { default: CallOperatorTariffZone },
      meta:{
        icon: "call",
        parentPath: "/call/tarification/service_providers",
        msgKey: 'menu.item.call.provider.routing'
      }
    },
    {
      path: "tarification/service_providers/:operator_id/tariff_zone/:id",
      name: "call_tarification_operators_edit",
      components: { default: CallOperatorTariffZone },
      meta:{
        icon: "call",
        parentPath: "/call/tarification/service_providers",
        msgKey: 'menu.item.call.provider.routing'
      }
    },
  ]
};

export default callMenu;
